import {
  COOKIE_PROFILE_USER,
  COOKIE_UPDATED_COOKIES,
  createCookie,
  getCookieUpdateCookies
} from '@wiggot/auth'
import type { IProfileUser } from '../../interfaces/src'

const STAGE = process.env.NEXT_PUBLIC_STAGE ?? ''

export const updateCookieProfile = (
  currentProfile: IProfileUser,
  newProfile: any
): IProfileUser => {
  const {
    agencyId = currentProfile?.agencyId,
    userId = currentProfile?.userId,
    profileId = currentProfile?.profileId,
    email = currentProfile?.email,
    fullname = currentProfile?.fullname,
    photo = currentProfile?.photo,
    verified = currentProfile?.verified,
    trialUsed = currentProfile?.trialUsed,
    primeType = currentProfile?.primeType,
    primeAvailableUntil = currentProfile?.primeAvailableUntil,
    fullPrimeUsed = currentProfile?.fullPrimeUsed,
    domain = currentProfile?.domain,
    subdomain = currentProfile?.subdomain,
    domainCertificateStatus = currentProfile?.domainCertificateStatus,
    userScoresSectionConfig = currentProfile?.userScoresSectionConfig,
    userPaymentStatus = currentProfile?.userPaymentStatus,
    phoneNumberVerified = currentProfile?.phoneNumberVerified,
    phoneNumber = currentProfile?.phoneNumber,
    notificationsReminder = currentProfile?.notificationsReminder,
    specialPermission = currentProfile?.specialPermission,
    agencyUsersWithPrime = currentProfile?.agencyUsersWithPrime,
    planAvailableUntil = currentProfile?.planAvailableUntil,
    planType = currentProfile?.planType,
    oldRoles = currentProfile?.oldRoles,
    fullPlanUsed = currentProfile?.fullPlanUsed,
    isOldPro = currentProfile?.isOldPro
  } = newProfile

  const termsAndConditions =
    newProfile?.termsAndConditions === null
      ? false
      : newProfile?.termsAndConditions

  const newValueCookieProfile: IProfileUser = {
    ...newProfile,
    userId,
    profileId,
    email,
    fullname,
    photo,
    verified,
    isLoading: false,
    agencyId,
    trialUsed,
    primeType,
    fullPrime: primeType === 'FULL_PRIME',
    primeAvailableUntil,
    fullPrimeUsed,
    domain,
    subdomain,
    domainCertificateStatus,
    userScoresSectionConfig,
    userPaymentStatus,
    phoneNumberVerified,
    phoneNumber,
    notificationsReminder,
    termsAndConditions,
    specialPermission,
    agencyUsersWithPrime,
    planAvailableUntil,
    planType,
    oldRoles,
    fullPlanUsed,
    isOldPro
  }

  const expirationDate = new Date()

  expirationDate.setDate(expirationDate?.getDate() + 365)

  const formattedDate = expirationDate?.toUTCString()

  const valueUpdateCookies = getCookieUpdateCookies()

  const date = new Date().toUTCString()

  const newValueUpdateCookies = valueUpdateCookies
    ? [
        ...valueUpdateCookies.filter(
          (cookie) => cookie.name !== COOKIE_PROFILE_USER
        ),
        { name: COOKIE_PROFILE_USER, lastUpdated: date }
      ]
    : [
        {
          name: COOKIE_PROFILE_USER,
          lastUpdated: date
        }
      ]

  createCookie({
    name: COOKIE_UPDATED_COOKIES,
    value: JSON.stringify(newValueUpdateCookies),
    date: formattedDate,
    httpOnly: false,
    secure: STAGE !== 'local'
  })

  createCookie({
    name: COOKIE_PROFILE_USER,
    value: JSON.stringify(newValueCookieProfile),
    date: formattedDate,
    httpOnly: false,
    secure: STAGE !== 'local'
  })

  return newValueCookieProfile
}
